import React, { useState } from 'react';
import { BOTTOM_INDENTS, COLORS, LEFT_INDENTS } from '@constants';
import { useStore } from '@hooks';
import { Button, Icon, Table } from '@ui';
import { formatString } from '@utils';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { MENU_ITEM_IDS } from '../../constants';
import { usePerformanceScrollFetch } from '../../hooks';
import CustomizeModal from './components/CustomizeModal';

const pageSize = 10;

const Reports = observer(({ date, onComponentViewUpdate }) => {
    const [initialFetchDone, setInitialFetch] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const store = useStore();
    const { reportsList, activeReportMetrics, downloadReports, pendingReports, getReports } = store.performanceStore;

    const { componentRef } = usePerformanceScrollFetch({
        initialFetchDone,
        onInitialFetch: () => {
            setInitialFetch(true);
            getReports(date);
        },
        onReFetch: () => {
            getReports(date);
        },
        onComponentViewUpdate,
        date
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
    };

    const generateColumns = (activeReportMetrics) => {
        return activeReportMetrics.map((metric) => ({
            ...metric,
            onHeaderCell: () => ({
                'data-e2e': `performance-reports_${formatString(metric.key)}_column-header`
            }),
            onCell: (record) => {
                const rowName = record[activeReportMetrics[0].dataIndex];
                return {
                    'data-e2e': `performance-reports_${formatString(rowName)}-row_${formatString(metric.key)}_value`
                };
            }
        }));
    };

    const columns = generateColumns(activeReportMetrics);

    return (
        <Row ref={componentRef} id={MENU_ITEM_IDS.REPORTS} data-e2e='performance_reports-section'>
            <CustomizeModal isModalOpen={isModalOpen} date={date} setIsModalOpen={setIsModalOpen} />
            <Col align='end' span={24} style={BOTTOM_INDENTS.M}>
                <Button
                    data-e2e='performance-reports_customize-columns_btn'
                    onClick={() => setIsModalOpen(true)}
                    style={LEFT_INDENTS.M}
                    icon={<Icon size='24px' color={COLORS.$gray60Black} component={() => <Icon.TableIcon />} />}
                    disabled={pendingReports}
                >
                    Customize columns
                </Button>
                <Button
                    data-e2e='performance-reports_download-scv_bottom-btn'
                    onClick={() => downloadReports(date)}
                    style={LEFT_INDENTS.M}
                    icon={<Icon size='24px' color={COLORS.$gray60Black} component={() => <Icon.DownloadIcon />} />}
                    disabled={pendingReports}
                >
                    Download CSV
                </Button>
            </Col>
            <Col span={24}>
                <Table
                    data-e2e='performance-reports_table'
                    dataSource={reportsList}
                    columns={columns}
                    loading={pendingReports}
                    onChange={handleTableChange}
                    pagination={{
                        showQuickJumper: true,
                        pageSize,
                        total: reportsList.length,
                        totalPages: Math.ceil(reportsList.length / pageSize),
                        current: currentPage
                    }}
                    expandPosition='left'
                />
            </Col>
        </Row>
    );
});

export default Reports;
